






































import Global from '@/js/global.js'
import BasePageTemplate from '@/views/templates/tenugui/BasePageTemplate.vue'
import MessageArea from '@/views/molecules/MessageArea.vue'
import PopupFirstQuiz from '@/views/templates/tenugui/PopupFirstQuiz.vue'
import PopupEpisode2_1 from '@/views/templates/tenugui/PopupEpisode2_1.vue'
import PopupEpisode2_2 from '@/views/templates/tenugui/PopupEpisode2_2.vue'
import PopupEpisode2_3 from '@/views/templates/tenugui/PopupEpisode2_3.vue'
import PopupEpisode2_4 from '@/views/templates/tenugui/PopupEpisode2_4.vue'
import PopupEpisode2_5 from '@/views/templates/tenugui/PopupEpisode2_5.vue'
import PopupEpisode2_6 from '@/views/templates/tenugui/PopupEpisode2_6.vue'

export default
  components: {
    BasePageTemplate
    MessageArea
    PopupFirstQuiz
    PopupEpisode2_1
    PopupEpisode2_2
    PopupEpisode2_3
    PopupEpisode2_4
    PopupEpisode2_5
    PopupEpisode2_6
  }

  data: () ->
    showPopup: 0
    showEpisodePopup: [0, 0, 0, 0, 0, 0]
    message: 'CHAORAS®（チャオラス）は<br>
日本の伝統的なものづくりから生み出されるモノのよさを<br>
新しいアイデアで現代にマッチさせ、<br>
次世代につなぐTradition & Innovationに<br>
チャレンジするブランドです。'

  mounted: () ->
    @scrollFire()

  methods: {
    reshowQuiz: (e) ->
      @showPopup = 1
    startScrollFire: () ->
      @$emit('scrollFire')
      result = await Global.checkPointHit('p2-2')
      if result
        return
      if @showPopup == 0
        @showPopup = 1
    close_popup: (code) ->
      @showPopup = code
    scrollFire: () ->
      top = document.querySelector('.space01').offsetTop + document.querySelector('.space01').offsetHeight
      left = (window.scrollY - top)
      if left < 0
        left = 0
      document.querySelector('.episode2 .lines .line').style.marginLeft = (-left) + 'px'
    show_episode_popup: (index) ->
      @$set(@showEpisodePopup, index, 1)
    close_episode_popup: (index) ->
      @$set(@showEpisodePopup, index, 0)
    add_point: (point) ->
      @$emit('addPoint', point)
  }
